import * as requestFromServer from './IconsCrud'
import { iconsSlice } from './IconsSlice'

const { actions } = iconsSlice

export const fetchIcons = ( queryParams ) => dispatch => {
    return requestFromServer
        .getIcons(queryParams)
        .then(( response ) => {
            dispatch(actions.iconsFetched({
                totalCount: response.data._count,
                entities: response.data.value
            }))
        }).catch((err) => {
            // dispatch(actions)
        })
}

export const createIcon = ( dataForm ) => dispatch => {
    // dispatch(actions.)
    return requestFromServer
        .createIcon(dataForm)
        .then((response) => {
            if ( response.status == 200 ) {
                console.log(response)
            }
        }).catch((err) => {
            console.log(err)
        })
}

export const selectIcon = ( icon ) => {

}

export const deleteIcon = ( id ) => dispatch => {
    return requestFromServer
        .deleteIcon(id)
        .then((response) => {
            
        }).catch((err) => {
            console.log(err)
        })
}

export const update = ( iconForm ) => dispatch => {
    return requestFromServer
        .updateIcon(iconForm)
        .then(() => {
            
        }).catch((err) => {
            console.log(err)
        })
}